const routes = [];
routes.push(
    /**
     * 定期报告校验结果页UI
     * http://192.168.18.44:8080/tool/showChkRst?path=s3%3A%2F%2Ftemp-002%2Fgm-demo.xml
     */
    /*{
        name : 'showChkRst',
        path : `/tool/showChkRst`,
        meta : { reqAuth: false },
        component: () => import( `@/toolViews/showChkRst` )
    },*/
);

routes.push(
    {
        name : 'user',
        path : `/user`,
        meta : { reqAuth: true },
        component: () => userIndexComp,
        // children:userRoutes
    }
)

// 阅读器新开页
routes.push({
	name: 'readerPage',
	path: '/readerPage',
	meta: {
		reqAuth: true
	},
	component: () => import('@/views/index/components/readerPage.vue'),
})// 阅读器新开页
routes.push({
	name: 'smartInsight',
	path: '/smartInsight',
	meta: {
		reqAuth: true,
		type : "xiaozhixiewen"
	},
	component: () => import('@/views/index/components/readerPage.vue'),
})
routes.push({
	name: 'smartGenie',
	path: '/smartGenie',
	meta: {
		reqAuth: true,
		type : "xiaozhijiedu"
	},
	component: () => import('@/views/index/components/readerPage.vue'),
})

routes.push({
	name: 'smartAnalyze',
	path: '/smartAnalyze',
	meta: {
		reqAuth: true,
		type : "xiaozhifenxi"
	},
	component: () => import('@/views/index/components/smartAnalyze.vue'),
})
routes.push({
	name: 'smartStudy',
	path: '/smartStudy',
	meta: {
		reqAuth: true,
		type : "xiaozhixuexi"
	},
	component: () => import('@/views/index/components/readerPage.vue'),
})
routes.push({
	name: 'smartPerspective',
	path: '/smartPerspective',
	meta: {
		reqAuth: true,
		type : "xiaozhitoushi"
	},
	component: () => import('@/views/index/components/smartPerspective.vue'),
})
routes.push({
	name: 'transfer',
	path: '/transfer',
	meta: {
		reqAuth: false,
	},
	component: () => import('@/views/index/components/readerTransfer.vue'),
})
routes.push({
	name: 'follow',
	path: '/follow',
	meta: {
		reqAuth: false,
	},
	component: () => import('@/views/index/components/readerFollow.vue'),
})
routes.push({
	name:"bigScreen",
	path:"/bigScreen",
	meta: {
		reqAuth: true,
		type : "/bigScreen"
	},
	component: () => import('@/views/bigScreen/bigScreen.vue'),
})

export default routes;
